module.exports = __webpack_public_path__ + "img/wheelchair.8c2abaf4.svg";